import React, { useState, useEffect } from "react";
import Form from "./Childs/Form";
import Description from "../../Common/Childs/Structure/Description";
import Title from "../../Common/Childs/Structure/Title";
import FormCard from "../../Common/Childs/Structure/FormCard";
import { useWallet } from "../../../context/WalletContextProvider";
import { useGlobal } from "../../../context/GlobalContextProvider";
import { getCampaignById } from "../../../utils/services";

/**
 * API Services
 */
const sponsorAPI = {
  getById: (sponsorId) =>
    fetch(`/api/sponsor/${sponsorId}`).then((res) => {
      if (res.status === 204 || !res.ok) return null;
      return res.json();
    }),
};

const beneficiaryAPI = {
  getById: (beneficiaryId) =>
    fetch(`/api/beneficiary/${beneficiaryId}`).then((res) => {
      if (res.status === 204 || !res.ok) return null;
      return res.json();
    }),
};

const campaignAPI = {
  updateWebsite: (account, campaignId, data) =>
    fetch(`/api/sponsor/${account}/campaign/website/${campaignId}`, {
      method: "PUT",
      body: JSON.stringify(data),
      headers: { "Content-type": "application/json; charset=UTF-8" },
    }),
};

/**
 * IndexWebsite Component
 * Manage campaign website settings
 */
const IndexWebsite = () => {
  const { account } = useWallet();
  const { campaign, setSpinner, setCampaign } = useGlobal();

  const [beneficiary, setBeneficiary] = useState({});
  const [sponsor, setSponsor] = useState({});

  /**
   * Load sponsor and beneficiary data
   */
  useEffect(() => {
    if (!campaign) return;

    const getData = async () => {
      try {
        setSpinner(true);
        const [sponsorData, beneficiaryData] = await Promise.all([
          sponsorAPI.getById(campaign.sponsor_id),
          beneficiaryAPI.getById(campaign.beneficiary_id),
        ]);
        setSponsor(sponsorData);
        setBeneficiary(beneficiaryData);
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setSpinner(false);
      }
    };

    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaign]);

  /**
   * Handle form submission
   */
  const handleUpdate = async (data) => {
    try {
      setSpinner(true);
      await campaignAPI.updateWebsite(account, campaign.campaign_id, data);
      await getCampaignById(account, campaign.campaign_id);
      setCampaign({ ...campaign, ...data });
    } catch (error) {
      console.error("Error updating website settings:", error);
    } finally {
      setSpinner(false);
    }
  };

  return (
    <>
      <Title title="Website Settings" />
      <Description text="Design the look and feel of your Campaign website with these settings." />
      <FormCard>
        <Form
          formData={campaign}
          handleSubmit={handleUpdate}
          beneficiary={beneficiary}
          sponsor={sponsor}
        />
      </FormCard>
    </>
  );
};

export default IndexWebsite;
